import type { DefaultRootState } from "react-redux";
import { createSelector } from "reselect";

export const getPricePlansInfo = (state: DefaultRootState) =>
  state.billing.plansInfo;

export const getPricePlansConfigLoading = (state: DefaultRootState) =>
  state.billing.isPricePlansConfigLoading;

export const getActiveUsers = (state: DefaultRootState) =>
  state.billing.activeUsers;

export const getUpcomingInvoiceSummaryIsLoading = (state: DefaultRootState) =>
  state.billing.isUpcomingInvoiceSummaryLoading;

export const getUpcomingInvoiceSummary = (state: DefaultRootState) =>
  state.billing.upcomingInvoiceSummary;

export const getUpcomingInvoiceSummaryPeriodEnd = createSelector(
  [getUpcomingInvoiceSummary],
  (upcomingInvoiceSummary) => upcomingInvoiceSummary?.periodEnd,
);

export const getInvoiceSummaryLineItems = createSelector(
  [getUpcomingInvoiceSummary],
  (upcomingInvoiceSummary) => upcomingInvoiceSummary?.lineItems || [],
);

export const getUpcomingInvoiceSummaryTotal = createSelector(
  [getUpcomingInvoiceSummary],
  (upcomingInvoiceSummary) => upcomingInvoiceSummary?.total,
);
